const mediaItems = [
  {
    title: '独家揭秘：某女星整容全纪录对比分析',
    duration: '15:42',
    views: '320万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20beauty%20clinic%20interior%20with%20dramatic%20lighting%2C%20mysterious%20vibe%2C%20mirrors%20and%20shadows%2C%20red%20accent%20lights%2C%20film%20noir%20aesthetic&width=800&height=450&seq=media-01&orientation=landscape',
    tag: '深度分析',
  },
  {
    title: '圈内人亲述：某综艺节目不为人知的剧本黑幕',
    duration: '22:18',
    views: '560万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20backstage%20with%20scripts%20and%20hidden%20papers%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20lighting%2C%20red%20and%20black%20tones&width=800&height=450&seq=media-02&orientation=landscape',
    tag: '独家爆料',
  },
  {
    title: '网红翻车大盘点：那些年塌房的千万粉丝主播',
    duration: '18:55',
    views: '890万',
    img: 'https://readdy.ai/api/search-image?query=Broken%20streaming%20equipment%20on%20dark%20desk%2C%20dramatic%20lighting%2C%20fallen%20ring%20light%2C%20mysterious%20bedroom%20studio%2C%20noir%20photography%20with%20red%20accents&width=800&height=450&seq=media-03&orientation=landscape',
    tag: '年度回顾',
  },
  {
    title: '明星税务风波：从罚款到封杀，谁在劫难逃？',
    duration: '12:30',
    views: '670万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20office%20with%20financial%20documents%20and%20red%20warning%20stamps%2C%20dramatic%20overhead%20light%2C%20mysterious%20tax%20investigation%20theme%2C%20noir%20style%2C%20black%20and%20red%20palette&width=800&height=450&seq=media-04&orientation=landscape',
    tag: '持续追踪',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">视频专区</h2>
          <span className="text-xs text-foreground-500 bg-background-200 px-2.5 py-1 rounded-full">精选</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-50/20"></div>
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-1 rounded-full bg-primary-500/90 text-background-50 font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-background-50/90 px-2 py-1 rounded text-xs text-foreground-700">
                  <i className="ri-play-circle-fill text-primary-500"></i>
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}播放
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-thumb-up-line"></i>
                    推荐
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}